import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Col, Row, Modal, Table, Card } from 'antd';
import styled from 'styled-components';
import { CloseCircleOutlined, EyeOutlined, WarningOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Text, Box } from 'atoms';
import { ACL } from 'components/common';
import { DAY_DATE_FORMAT } from 'utils';
import { showLoader } from 'store/appSlice';
import { getContractExpire } from 'store/commonSlice';

const BoxText = styled(Box)`
	font-size: 15px;
	font-weight: 500;
`;

const ContainerModal = styled(Box)`
	padding: 20px 0;
`;

const MessageWrap = styled(Card)`
	font-size: 16px;
	border-radius: 4px;
	margin-bottom: 16px;
	> .ant-card-body {
		padding: 10px 16px;
		:before {
			height: calc(100% - 22px);
			background: #6e57f9;
			width: 2px;
			border-radius: 2px;
			position: absolute;
			left: -1px;
			top: 12px;
		}
	}
`;

const ViewDetails = styled(Col)`
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		color: red;
	}
`;

function ClientContract() {
	const dispatch = useDispatch();
	const [totalCientDataCount, setTotalCientDataCount] = useState(0);
	const [openClientModal, setClientModal] = useState(false);
	const [rowClinetData, setClientRowData] = useState({});

	const ClientContractsTableConfig = [
		{
			title: ' ',
			dataIndex: 'already_expired',
			key: 'already_expired',
			hidden: false,
			width: 30,
			render: (already_expired) => (
				<Box>
					<Box>
						{' '}
						{already_expired === true && (
							<CloseCircleOutlined
								style={{
									color: 'red',
									fontSize: '14px',
								}}
							/>
						)}{' '}
					</Box>
					<Box>
						{' '}
						{already_expired === false && (
							<WarningOutlined
								style={{
									color: 'orange',
									fontSize: '14px',
								}}
							/>
						)}{' '}
					</Box>
				</Box>
			),
		},
		{
			title: 'Client Name',
			dataIndex: 'client_name',
			key: 'client_name',
			hidden: false,
			width: 220,
			render: (client_name) => <Text overFlow="hidden">{client_name || ''}</Text>,
		},
		{
			title: 'Project Location code',
			dataIndex: 'project_location_code',
			key: 'project_location_code',
			hidden: false,
			width: 180,
			render: (project_location_code) => (
				<Text overFlow="hidden">{project_location_code || ''}</Text>
			),
		},
		{
			title: 'Vehicle Type',
			dataIndex: 'vehicle_type',
			key: 'vehicle_type',
			hidden: false,
			width: 120,
			render: (vehicle_type) => <Text overFlow="hidden">{vehicle_type || ''}</Text>,
		},
		{
			title: 'City',
			dataIndex: 'city',
			key: 'city',
			hidden: false,
			width: 100,
			render: (city) => <Text overFlow="hidden">{city || ''}</Text>,
		},
		{
			title: 'Contract Date',
			dataIndex: 'contract_date',
			key: 'contract_date',
			hidden: false,
			width: 110,
			render: (contract_date) => (
				<Text overFlow="hidden">{moment(contract_date).format(DAY_DATE_FORMAT) || ''}</Text>
			),
		},
		{
			title: 'Expiry Date',
			dataIndex: 'expiry_date',
			key: 'expiry_date',
			width: 110,
			hidden: false,
			render: (expiry_date) => (
				<Text overFlow="hidden">{moment(expiry_date).format(DAY_DATE_FORMAT) || ''}</Text>
			),
		},
		{
			title: 'View',
			dataIndex: 'id',
			key: 'id',
			hidden: false,
			render: (id) => (
				<ACL action="update" module="client_contract">
					<Link to={`/client-contracts/${id}`}>
						<EyeOutlined />
					</Link>
				</ACL>
			),
		},
	];

	const handleChange = (pagination) => {
		// console.log(pagination);
		dispatch(showLoader());
		const offset = pagination.current * pagination.pageSize - pagination.pageSize;
		// console.log(offset);

		dispatch(
			getContractExpire({
				search_type: 'client_contract',
				offset,
				limit: pagination.pageSize,
			})
		).then((result) => {
			setClientRowData(result?.data);
			setTotalCientDataCount(result?.meta?.count);
		});
	};

	useEffect(() => {
		dispatch(
			getContractExpire({
				search_type: 'client_contract',
			})
		).then((res) => {
			// console.log(res);
			setClientRowData(res?.data);
			setTotalCientDataCount(res?.meta?.count);
		});
	}, []);

	return (
		<>
			{totalCientDataCount.total > 0 && (
				<MessageWrap>
					<Row justify="space-between">
						<Col>
							<WarningOutlined
								style={{
									color: '#6e57f9',
									marginRight: '8px',
								}}
							/>
							<span
								style={{
									color: '#6e57f9',
								}}
							>
								Client Contract Expiry :
							</span>
							<span
								style={{
									color: 'red',
									margin: '0 16px',
								}}
							>
								{`It Looks like ${totalCientDataCount?.already_expired} contract are Expired.`}
							</span>
							<span style={{ marginRight: '16px' }}>|</span>
							{`and ${totalCientDataCount?.about_to_expire} contract is going to expire in few days`}
						</Col>

						<ViewDetails onClick={() => setClientModal(true)}>View Details</ViewDetails>
					</Row>
				</MessageWrap>
			)}
			<Modal
				title="Client Contract Expiry List"
				style={{
					top: 20,
				}}
				open={openClientModal}
				onOk={() => setClientModal(false)}
				onCancel={() => setClientModal(false)}
				width={1000}
				height={500}
			>
				<Box>
					<Row justify="space-between">
						<Col>
							<BoxText>
								{' '}
								<CloseCircleOutlined
									style={{
										color: 'red',
										fontSize: '14px',
									}}
								/>{' '}
								&nbsp; Expired: {totalCientDataCount?.already_expired}
								<span> &nbsp; &nbsp;</span>
								<WarningOutlined
									style={{
										color: 'orange',
										fontSize: '14px',
									}}
								/>
								&nbsp; About to Expire: {totalCientDataCount?.about_to_expire}
							</BoxText>
						</Col>
						<Col></Col>
					</Row>
				</Box>
				<ContainerModal>
					{totalCientDataCount?.total > 0 && (
						<Table
							rowKey={(rowItem) => rowItem.id}
							columns={ClientContractsTableConfig}
							dataSource={rowClinetData}
							onChange={handleChange}
							scroll={{ y: 540 }}
							pagination={{
								total: totalCientDataCount?.total,
							}}
						/>
					)}
				</ContainerModal>
			</Modal>
		</>
	);
}

export default ClientContract;
